import Link from "next/link"
import slugify from "utilities/slugify"
import cn from "classnames"
import Image from "components/Image"
import Placeholder from "public/assets/team-member-placeholder.svg"

export default function GroomerCard({ name, title, image, visible, hash, section, _uid }) {
  const href = section === "team-member" ? `${slugify(name)}-${_uid.slice(0, 6)}` : hash

  return (
    <div
      className={cn(
        "max-w-[186px] shadow-xl hover:shadow-2xl rounded-3xl bg-white mx-3 my-1 transform transition-all duration-500 hover:-translate-y-1 flex flex-col",
        {
          "translate-y-0 opacity-1": visible,
          "translate-y-10 opacity-0": !visible,
        }
      )}
    >
      <Link href={`#${href}`} className="aspect-square w-[186px]">
        {image.filename ? (
          <Image
            src={image.filename}
            alt={image?.alt}
            width={186}
            height={186}
            className="aspect-square min-w-[186px] object-cover"
          />
        ) : (
          <Placeholder className="text-green-apple" width={186} height={186} />
        )}
      </Link>
      <div className="p-4 flex flex-col h-full">
        <h3 className="text-m1 text-center leading-6 pt-2 pb-2.5 hover:underline">
          <Link href={`#${href}`}>{name}</Link>
        </h3>
        <h4 className="text-s1 font-medium uppercase text-center">{title}</h4>
      </div>

      <div className="bg-green-apple pt-4 pb-5 px-4 text-center rounded-b-3xl">
        <Link
          className="portfolio-link underline hover:no-underline text-s1 mx-auto uppercase text-black font-medium"
          href={`#${hash}`}
        >
          View Portfolio
        </Link>
      </div>
    </div>
  )
}
